module.exports = ".card-body {\r\n    width: 100%;\r\n    position: relative;\r\n    overflow: scroll;\r\n}"